/**
 * Application Routes
 *
 * Defines the routing structure for the support app.
 * All routes except /login are protected by the auth guard.
 */

import { Routes } from '@angular/router';
import { authGuard, roleGuard } from './_services/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: '',
    loadComponent: () =>
      import('./components/layout/shell.component').then(
        (m) => m.ShellComponent
      ),
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'users',
        pathMatch: 'full',
      },
      {
        path: 'users',
        loadComponent: () =>
          import('./pages/users/users.component').then((m) => m.UsersComponent),
      },
      {
        path: 'chat',
        loadComponent: () =>
          import('./pages/chat/chat.component').then((m) => m.ChatComponent),
      },
      {
        path: 'feedback',
        loadComponent: () =>
          import('./pages/feedback/feedback.component').then(
            (m) => m.FeedbackComponent
          ),
      },
      {
        path: 'delete-reports',
        loadComponent: () =>
          import('./pages/delete-reports/delete-reports.component').then(
            (m) => m.DeleteReportsComponent
          ),
      },
      {
        path: 'segments',
        loadComponent: () =>
          import('./pages/segments/segments.component').then(
            (m) => m.SegmentsComponent
          ),
        canActivate: [roleGuard('agent')],
      },
      {
        path: 'admin',
        loadComponent: () =>
          import('./pages/admin/admin.component').then((m) => m.AdminComponent),
        canActivate: [roleGuard('admin')],
      },
      {
        path: 'schema',
        loadComponent: () =>
          import('./pages/schema/schema.component').then(
            (m) => m.SchemaComponent
          ),
        canActivate: [roleGuard('admin')],
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
